<template>
  <div>
    <a-form-model
      ref="form"
      :model="payload"
      :rules="rules">
      <a-form-model-item prop="name">
        <j-name v-model="user.name" placeholder="Nombre completo" :read-only="true" />
      </a-form-model-item>
      <a-form-model-item prop="email">
        <j-email v-model="user.email" placeholder="Email de contacto" :read-only="true" />
      </a-form-model-item>
      <a-form-model-item prop="address">
        <j-address v-model="payload.address" placeholder="Dirección de residencia" />
      </a-form-model-item>
      <a-form-model-item prop="floor">
        <j-floor v-model="payload.floor" placeholder="Piso/Departamento" />
      </a-form-model-item>
      <a-form-model-item prop="phone">
        <j-phone v-model="payload.phone" placeholder="Teléfono de contacto" />
      </a-form-model-item>
      <a-form-model-item prop="identification">
        <j-identification v-model="payload.identification" placeholder="Número de DNI" />
      </a-form-model-item>
      <a-form-model-item prop="vehicleType">
        <a-radio-group v-model="payload.vehicleType">
          <a-radio-button value="bike">
            Bici
          </a-radio-button>
          <a-radio-button value="motorbike">
            Moto
          </a-radio-button>
          <a-radio-button value="car">
            Auto
          </a-radio-button>
          <a-radio-button value="van">
            Utilitario
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-button type="primary" shape="round" size="large" :loading="posting" @click="onNext">
        Enviar
      </a-button>
    </a-form-model>
  </div>
</template>

<script>
import JAddress from './address'
import JFloor from './floor'
import JName from './name'
import JPhone from './phone'
import JEmail from './email'
import JIdentification from './identification'

import validators from '../validators'

export default {
  name: 'Form',
  props: [ 'posting' ],
  components: {
    JAddress,
    JFloor,
    JName,
    JPhone,
    JEmail,
    JIdentification,
  },
  data: function () {
    return {
      payload: {
        address: null,
        floor: null,
        name: null,
        phone: null,
        email: null,
        vehicleType: null,
      },
      rules: {
        address: [
          { validator: validators.address, trigger: 'change' },
        ],
        phone: [
          { validator: validators.phone, trigger: 'change' },
        ],
        identification: [
          { validator: validators.identification, trigger: 'change' },
        ],
        vehicleType: [
          { validator: validators.vehicleType, trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    user() {
      return this.$auth.user
    },
  },
  methods: {
    onNext() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('submit', {
            contact: {
              name: this.user.name,
              email: this.user.email,
              phone: this.payload.phone,
              identification: this.payload.identification,
            },
            address: {
              street: this.payload.address.address,
              apartment: this.payload.floor,
              city: this.payload.address.city,
              state: this.payload.address.state,
              country: this.payload.address.country,
              zip: this.payload.address.zip_code,
              lat: this.payload.address.lat,
              lng: this.payload.address.lng,
            },
            type: 'SINGLE',
            vehicle: this.payload.vehicleType,
          })
        }
      })
    },
  },
}
</script>
